import { actionCreatorFactory } from "typescript-fsa";

import { EntityInstancePath, FieldInstanceValue, GroupInstance } from "@com.mgmtp.a12.kernel/kernel-md-facade";

const factory = actionCreatorFactory("MODULF");

export const editOverviewDocument = factory<EditOverviewDocumentPayload>("EDIT_OVERVIEW_DOCUMENT");

export interface EditOverviewDocumentPayload {
	/**
	 * Target activity id
	 */
	readonly activityId: string;

	readonly modelId: string;

	/** The instanceId of the selected row/document */
	readonly instanceId: string;

	readonly fvKey?: string;
	readonly readonly: boolean;
	readonly srcEvent: "EVENT_BUTTON" | "ROW_CLICK" | "BUTTON_CLICK";
}
export const updateOverviewDocument = factory<UpdateOverviewDocumentPayload>("UPDATE_OVERVIEW_DOCUMENT");

export interface UpdateOverviewDocumentPayload {
	/**
	 * The original overview document (row in overview). Note that we cannot assume this document is complete!
	 */
	readonly originalDocument: GroupInstance;
	/**
	 * The overview activity ID.
	 */
	readonly activityId: string;
	readonly updates: [EntityInstancePath, FieldInstanceValue | undefined][];
}

export const didUpdateOverviewDocument = factory<DidUpdateOverviewDocumentPayload>("DID_UPDATE_OVERVIEW_DOCUMENT");

export interface DidUpdateOverviewDocumentPayload {
	/**
	 * The updated overview document (row in overview)
	 */
	readonly updatedDocument: GroupInstance;
	/**
	 * The overview activity ID. Note that the associated overview could be gone by now since this is async.
	 */
	readonly activityId: string;
}
